import { Form, Table } from "react-bootstrap";
import ToolBar from "../../../Componant/ToolBar";
import UseToggle from "../../../../Hooks/UseToggle";
import { useState } from "react";
import AddCategory from "./AddCategory";
import UpdateCategory from "./UpdateCategory";
import Moment from "react-moment";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { blogCategoryServices } from "../../../../APIServices/SitePilotManagement/BlogManagement/blogCategoryServices";

const CategoryManagement = ({getActiveBlogCategoryList}) => {
  const toggles = UseToggle();
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [blogCategories, setBlogCategories] = useState([]);
  const [blogCategoryData, setBlogCategoryData] = useState("");
  const [blogCategoryCount, setBlogCategoryCount] = useState(0);
  const [blogCategoryIds, setBlogCategoryIds] = useState([]);

  const toggleSingle = (id) => {
    setBlogCategoryIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  const toggleAll = () => {
    if (blogCategoryIds.length === blogCategories.length) {
      setBlogCategoryIds([]);
    } else {
      setBlogCategoryIds(blogCategories.map((c) => c.id));
    }
  };

  const isAllChecked =
    blogCategories.length > 0 && blogCategoryIds.length === blogCategories.length;
  const isChecked = (id) => blogCategoryIds.includes(id);

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalPages = Math.ceil(blogCategoryCount / itemsPerPage);

  const start = (pageNumber - 1) * itemsPerPage + 1;
  const end = Math.min(pageNumber * itemsPerPage, blogCategoryCount);

  const getBlogCategoryList = async () => {
    setLoader(true);
    let data = await blogCategoryServices.getBlogCategoryList(
      "all",
      search,
      pageNumber,
      itemsPerPage,
    );
    setBlogCategories(data?.data || []);
    setBlogCategoryCount(data?.count || 0);
    setLoader(false);
  };

  const updatedBlogCategory = async (categoryId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${status} this Blog Category?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${status} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.categoryId = categoryId;
        userData.status = status;
        let data = await blogCategoryServices.updatedBlogCategory(userData);
        if (data?.statusCode === 200) {
          getActiveBlogCategoryList();
          getBlogCategoryList();
        }
      }
    });
  };

  const deleteBlogCategory = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this Blog Category?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.categoryIds = blogCategoryIds;
        let data = await blogCategoryServices.deleteBlogCategory(userData);
        if (data?.statusCode === 200) {
          getActiveBlogCategoryList();
          getBlogCategoryList();
        }
      }
    });
  };

  useEffect(() => {
    let blogCategoryData = blogCategories?.find(
      (item) => item.categoryId === blogCategoryIds?.[0],
    );
    setBlogCategoryData(blogCategoryData || "");
  }, [blogCategoryIds]);

  useEffect(() => {
    getBlogCategoryList();
  }, [search, pageNumber, itemsPerPage]);

  return (
    <>
      <ToolBar
        toggles={toggles}
        search={search}
        setSearch={setSearch}
        checkedIds={blogCategoryIds}
        setCheckedIds={setBlogCategoryIds}
        start={start}
        end={end}
        totalItems={blogCategoryCount}
        page={pageNumber}
        setPage={setPageNumber}
        setPageSize={setItemsPerPage}
        pageSize={itemsPerPage}
        totalPages={totalPages}
        deleteData={deleteBlogCategory}
        addField
        editField
      />
      <div className={`contacts-layout`}>
        <div
          className={`table-section overflow-auto bg-white `}
          style={{ height: "calc(100vh - 182px)" }}
        >
          <Table
            hover
            className="contacts-table mb-0"
            style={{ verticalAlign: "middle" }}
          >
            <thead>
              <tr>
                <th>
                  <div className="d-flex align-items-center gap-2">
                    <div className="px-2">
                      <Form.Check
                        type="checkbox"
                        checked={isAllChecked}
                        onChange={toggleAll}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                    <div>Category</div>
                  </div>
                </th>
                <th>Total Post</th>
                <th>Status</th>
                <th>Created Date | Time</th>
                <th>Updated Date | Time</th>
              </tr>
            </thead>
            <tbody>
              {blogCategories?.map((item) => (
                <tr key={item.categoryId}>
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <div className="px-2">
                        <Form.Check
                          type="checkbox"
                          checked={isChecked(item.categoryId)}
                          onChange={() => toggleSingle(item.categoryId)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      <div>
                        <div className="fw-medium">{item.name}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span className="fw-medium">{item.totalPost || 0}</span>
                  </td>
                  <td>
                    <Form.Check
                      type="switch"
                      onChange={() =>
                        updatedBlogCategory(
                          item?.categoryId,
                          item.status === "active" ? "inactive" : "active",
                        )
                      }
                      checked={item.status === "active"}
                    />
                  </td>
                  <td>
                    <span className="fw-medium">
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item?.createdAt}
                      </Moment>
                    </span>
                  </td>
                  <td>
                    <span className="fw-medium">
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item?.updatedAt}
                      </Moment>
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
      <AddCategory
        show={!toggles.toggle}
        hide={() => toggles.setToggle()}
        title={`Add Category`}
        getBlogCategoryList={getBlogCategoryList}
        getActiveBlogCategoryList={getActiveBlogCategoryList}
      />
      <UpdateCategory
        show={!toggles.toggle1}
        hide={() => toggles.setToggle1()}
        title={`Update Category`}
        blogCategoryData={blogCategoryData}
        setBlogCategoryData={setBlogCategoryData}
        setBlogCategoryIds={setBlogCategoryIds}
        getBlogCategoryList={getBlogCategoryList}
        getActiveBlogCategoryList={getActiveBlogCategoryList}
      />
    </>
  );
};

export default CategoryManagement;
